import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { GamedayActionTypes, GamedayActionUnion, SetFilters } from './actions';
import { GamedayFiltersState } from './state';

@Injectable()
export class GamedayDataEffects {
  
  public readonly filter: Observable<GamedayActionUnion> = createEffect(() => this.actions.pipe(
    ofType(
      GamedayActionTypes.FilterBySealedBid,
      GamedayActionTypes.FilterByStock,
      GamedayActionTypes.FilterBySeries,
      GamedayActionTypes.FilterByLegends
    ),
    map((action: GamedayActionUnion) => {
      switch (action.type) {
        case GamedayActionTypes.FilterBySealedBid:
          return new SetFilters({
            isSealedBid: action.payload
          } as GamedayFiltersState);

        case GamedayActionTypes.FilterByStock:
          return new SetFilters({
            ignoreStocks: action.payload
          } as GamedayFiltersState);

        case GamedayActionTypes.FilterBySeries:
          return new SetFilters({
            seriesId: action.payload
          } as GamedayFiltersState);

        case GamedayActionTypes.FilterByLegends:
          return new SetFilters({
            legendCategories: action.payload
          } as GamedayFiltersState);

        default:
          return undefined;
      }
    }),
    filter((action) => !!action)
  ));

  constructor(private readonly actions: Actions) {}
}
